import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
  en: {
    translation: {
      // Welcome section
      "welcome": "Welcome to Happy Tails",
      "welcome_subtitle": "Your comprehensive pet care management system",
      "logged_in_as": "Logged in as",
      
      // Dashboard overview sections
      "todos_reminders": "ToDos & Reminders",
      "veterinary_appointments": "Veterinary Appointments",
      "today": "Today",
      "upcoming": "Upcoming",
      "daycare_checked_in": "Daycare - Currently Checked In",
      "hotel_checked_in": "Hotel - Currently Checked In",
      "hotel_upcoming": "Hotel - Upcoming Bookings",
      "owner": "Owner",
      "until": "Until",
      "loading_dashboard": "Loading dashboard overview...",
      "failed_load_dashboard": "Failed to load dashboard overview",
      "no_date": "No date",
      "no_time": "No time",
      "invalid_date": "Invalid date",
      "invalid_time": "Invalid time",
      "unknown_dog": "Unknown Dog",
      "general_checkup": "General checkup",
      "in": "In",
      
      // Sticky Notes
      "sticky_notes": "Sticky Notes",
      "add_note": "Add Note",
      "edit_note": "Edit Note",
      "new_note": "New Note",
      "note_title": "Title",
      "note_content": "Content",
      "note_color": "Color",
      "created_by": "Created by",
      "edited_by": "Edited by",
      "delete_note_confirm": "Are you sure you want to delete this note?",
      "no_notes": "No notes yet. Add one!",
      "note_title_placeholder": "Enter note title...",
      "note_content_placeholder": "Write your note here...",
      "notes_history": "History",
      "completed_notes": "Completed",
      "deleted_notes": "Deleted",
      "no_completed_notes": "No completed notes yet.",
      "no_deleted_notes": "No deleted notes.",
      "marked_done_by": "Completed by",
      "deleted_by_label": "Deleted by",
      "page": "Page",
      "of": "of",
      "see_all": "See all",
      "mark_complete": "Mark complete",
      "restore": "Restore",
      "restore_note": "Restore to active notes",
      "note_restored": "Note restored",

      // POS / Sales
      "pos_title": "Sales",
      "pos_new_sale": "New sale",
      "pos_sale": "Sale",
      "pos_customer": "Customer",
      "pos_select_dog": "Select a dog",
      "pos_owner_autofilled": "Owner is auto-filled",
      "pos_change": "Change",
      "pos_items": "Items",
      "pos_add_item": "Add item",
      "pos_no_items_yet": "No items yet",
      "pos_discount": "Discount",
      "pos_percent": "% Percent",
      "pos_amount": "$ Amount",
      "pos_subtotal": "Subtotal",
      "pos_discount_line": "Discount",
      "pos_total_due": "Total due",
      "pos_total": "Total",
      "pos_payments": "Payments",
      "pos_record_payment": "Record payment",
      "pos_record_first_payment": "Record first payment",
      "pos_remaining": "Remaining balance",
      "pos_fully_paid": "Fully paid",
      "pos_pay_rest": "Pay rest",
      "pos_cash": "Cash",
      "pos_card": "Card",
      "pos_bit": "Bit",
      "pos_transfer": "Transfer",
      "pos_today": "Today",
      "pos_yesterday": "Yesterday",
      "pos_custom_date": "Custom date",
      "pos_save_payment": "Save payment",
      "pos_save_and_pay": "Save & take payment",
      "pos_complete_sale": "Complete sale",
      "pos_add_items_to_start": "Add items to start",
      "pos_sales": "Sales",
      "pos_today_revenue": "Today",
      "pos_outstanding": "Outstanding",
      "pos_all": "All",
      "pos_paid": "Paid",
      "pos_partial": "Partial",
      "pos_due": "Due",
      "pos_sale_completed": "Sale completed",
      "pos_sale_saved_due": "Sale saved · due",
      "pos_sale_saved_unpaid": "Sale saved · unpaid",

      // Halloween season
      "halloween_title": "🎃 Halloween season at Happy Tails 👻",
      "halloween_subtitle": "Bats, costumes and plenty of treats — may the schedule be the only scary thing today! 🐾",
      "halloween_dismiss": "Close"
    }
  },
  es: {
    translation: {
      // Welcome section
      "welcome": "Bienvenido a Happy Tails",
      "welcome_subtitle": "Tu sistema integral de gestión de cuidado de mascotas",
      "logged_in_as": "Conectado como",
      
      // Dashboard overview sections
      "todos_reminders": "Tareas y Recordatorios",
      "veterinary_appointments": "Citas Veterinarias",
      "today": "Hoy",
      "upcoming": "Próximas",
      "daycare_checked_in": "Guardería - Actualmente Registrados",
      "hotel_checked_in": "Hotel - Actualmente Registrados",
      "hotel_upcoming": "Hotel - Reservas Próximas",
      "owner": "Propietario",
      "until": "Hasta",
      "loading_dashboard": "Cargando resumen del panel...",
      "failed_load_dashboard": "No se pudo cargar el resumen del panel",
      "no_date": "Sin fecha",
      "no_time": "Sin hora",
      "invalid_date": "Fecha inválida",
      "invalid_time": "Hora inválida",
      "unknown_dog": "Perro Desconocido",
      "general_checkup": "Chequeo general",
      "in": "Entrada",
      
      // Common form labels and buttons
      "name": "Nombre",
      "email": "Correo electrónico",
      "phone": "Teléfono",
      "address": "Dirección",
      "date": "Fecha",
      "time": "Hora",
      "notes": "Notas",
      "description": "Descripción",
      "save": "Guardar",
      "cancel": "Cancelar",
      "edit": "Editar",
      "delete": "Eliminar",
      "add": "Agregar",
      "create": "Crear",
      "update": "Actualizar",
      "search": "Buscar",
      "filter": "Filtrar",
      "submit": "Enviar",
      "reset": "Restablecer",
      "close": "Cerrar",
      "confirm": "Confirmar",
      "loading": "Cargando...",
      "error": "Error",
      "success": "Éxito",
      "warning": "Advertencia",
      "info": "Información",
      
      // Dog-related terms
      "breed": "Raza",
      "age": "Edad",
      "weight": "Peso",
      "gender": "Sexo",
      "male": "Macho",
      "female": "Hembra",
      "color": "Color",
      "size": "Tamaño",
      "small": "Pequeño",
      "medium": "Mediano",
      "large": "Grande",
      
      // Status terms
      "active": "Activo",
      "inactive": "Inactivo",
      "pending": "Pendiente",
      "completed": "Completado",
      "cancelled": "Cancelado",
      "confirmed": "Confirmado",
      
      // Time-related terms
      "start_date": "Fecha de inicio",
      "end_date": "Fecha de fin",
      "check_in": "Entrada",
      "check_out": "Salida",
      "duration": "Duración",
      
      // Common placeholders
      "enter_name": "Ingrese el nombre",
      "enter_email": "Ingrese el correo electrónico",
      "enter_phone": "Ingrese el teléfono",
      "select_date": "Seleccione una fecha",
      "select_time": "Seleccione una hora",
      "optional": "Opcional",
      "required": "Requerido",
      
      // Quick access card descriptions
      "dogs_desc": "Gestionar perfiles de perros, propietarios e información detallada",
      "daycare_desc": "Gestión diaria, registros de entrada y asignación de paquetes",
      "hotel_desc": "Gestión de reservas y servicios de alojamiento",
      "veterinary_desc": "Citas médicas, historiales de salud y atención",
      "grooming_desc": "Citas de peluquería y servicios de belleza para mascotas",
      
      // Sticky Notes
      "sticky_notes": "Notas Adhesivas",
      "add_note": "Agregar Nota",
      "edit_note": "Editar Nota",
      "new_note": "Nueva Nota",
      "note_title": "Título",
      "note_content": "Contenido",
      "note_color": "Color",
      "created_by": "Creado por",
      "edited_by": "Editado por",
      "delete_note_confirm": "¿Estás seguro de que quieres eliminar esta nota?",
      "no_notes": "No hay notas aún. ¡Agrega una!",
      "note_title_placeholder": "Ingrese el título de la nota...",
      "note_content_placeholder": "Escribe tu nota aquí...",
      "notes_history": "Historial",
      "completed_notes": "Completadas",
      "deleted_notes": "Eliminadas",
      "no_completed_notes": "No hay notas completadas aún.",
      "no_deleted_notes": "No hay notas eliminadas.",
      "marked_done_by": "Completado por",
      "deleted_by_label": "Eliminado por",
      "page": "Página",
      "of": "de",
      "see_all": "Ver todo",
      "mark_complete": "Marcar como completado",
      "restore": "Restaurar",
      "restore_note": "Restaurar a notas activas",
      "note_restored": "Nota restaurada",

      // POS / Ventas
      "pos_title": "Ventas",
      "pos_new_sale": "Nueva venta",
      "pos_sale": "Venta",
      "pos_customer": "Cliente",
      "pos_select_dog": "Seleccionar perro",
      "pos_owner_autofilled": "El dueño se completa automáticamente",
      "pos_change": "Cambiar",
      "pos_items": "Ítems",
      "pos_add_item": "Agregar ítem",
      "pos_no_items_yet": "Sin ítems aún",
      "pos_discount": "Descuento",
      "pos_percent": "% Porcentaje",
      "pos_amount": "$ Monto",
      "pos_subtotal": "Subtotal",
      "pos_discount_line": "Descuento",
      "pos_total_due": "Total a pagar",
      "pos_total": "Total",
      "pos_payments": "Pagos",
      "pos_record_payment": "Registrar pago",
      "pos_record_first_payment": "Registrar primer pago",
      "pos_remaining": "Saldo pendiente",
      "pos_fully_paid": "Pagado completo",
      "pos_pay_rest": "Pagar resto",
      "pos_cash": "Efectivo",
      "pos_card": "Tarjeta",
      "pos_bit": "Bit",
      "pos_transfer": "Transferencia",
      "pos_today": "Hoy",
      "pos_yesterday": "Ayer",
      "pos_custom_date": "Fecha personalizada",
      "pos_save_payment": "Guardar pago",
      "pos_save_and_pay": "Guardar y cobrar",
      "pos_complete_sale": "Completar venta",
      "pos_add_items_to_start": "Agrega ítems para comenzar",
      "pos_sales": "Ventas",
      "pos_today_revenue": "Hoy",
      "pos_outstanding": "Pendiente",
      "pos_all": "Todos",
      "pos_paid": "Pagados",
      "pos_partial": "Parcial",
      "pos_due": "Pendiente",
      "pos_sale_completed": "Venta completada",
      "pos_sale_saved_due": "Venta guardada · pendiente",
      "pos_sale_saved_unpaid": "Venta guardada · sin pagar",

      // Temporada de Halloween
      "halloween_title": "🎃 Temporada de Halloween en Happy Tails 👻",
      "halloween_subtitle": "Murciélagos, disfraces y muchas golosinas — ¡que lo único que asuste hoy sea la agenda! 🐾",
      "halloween_dismiss": "Cerrar"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es', // Default to Spanish
    fallbackLng: 'en',
    
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;